import React from 'react';
import { Breadcrumbs, Grid, SpaceWrapper, StickyNavigation } from '../../ui-toolkit/components';
import { UserProfileContainer } from 'components/userProfile/UserProfileContainer';
import { CreateLenderContainer } from 'components/lenders/CreateLenderContainer';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';

export const LenderCompanyCreatePage: React.FC = () => (
  <>
    <StickyNavigation activeMain={'Lenders'} profile={<UserProfileContainer />} />
    <SpaceWrapper topSpace={'none'}>
      <Grid>
        <Breadcrumbs
          homeLink={ClientUrlFactory().urlFor.adminOrders()}
          links={[
            {
              to: ClientUrlFactory().urlFor.lendersIndex(),
              text: 'Lenders',
            },
          ]}
        />
        <CreateLenderContainer />
      </Grid>
    </SpaceWrapper>
  </>
);
